import { render } from "./messenger-button.vue?vue&type=template&id=1daaac30"
import script from "./messenger-button.vue?vue&type=script&lang=js"
export * from "./messenger-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__